import { render } from "./HomeEng.vue?vue&type=template&id=3afc7fe0"
import script from "./HomeEng.vue?vue&type=script&lang=js"
export * from "./HomeEng.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__